export default __webpack_public_path__ + "static/media/icons8-cloud-share-symbol-100.e13e3b14.svg";